// extracted by mini-css-extract-plugin
module.exports = {"card":"_3nV5lXlcasfqIs3EZWFLiA==","title":"kN20PIp0INBxp63vIkad4w==","topic":"_4IbWaNe7z77nEx9n6i460Q==","content":"OklgKNzLINdzIK3QrohF2g==","value":"XzR9Ezoj-xSpKSt16f0bBA=="};